/**
 * Responsive CSS for core hero-content templates.
 */
export const HERO_CONTENT_RESPONSIVE_CSS = `
  @media only screen and (max-width: 768px) {
    .hero-content-standard .hero-content-heading,
    .hero-content-dark-centered .hero-content-heading,
    .hero-content-centered-light .hero-content-heading,
    .hero-content-banner-image .hero-content-heading,
    .hero-content-accent-line .hero-content-heading,
    .hero-content-overlay-minimal .hero-content-heading {
      font-size: 24px !important;
    }
    .hero-content-minimal .hero-content-heading {
      font-size: 28px !important;
    }
    .hero-content-split .hero-content-heading {
      font-size: 24px !important;
    }
    .hero-content-standard .hero-content-text,
    .hero-content-dark-centered .hero-content-text,
    .hero-content-split .hero-content-text,
    .hero-content-minimal .hero-content-text,
    .hero-content-centered-light .hero-content-text,
    .hero-content-banner-image .hero-content-text,
    .hero-content-accent-line .hero-content-text,
    .hero-content-overlay-minimal .hero-content-text {
      font-size: 14px !important;
    }
    .hero-content-button-wrap {
      text-align: center !important;
    }
    .hero-content-split .hero-split-image,
    .hero-content-split .hero-split-image-placeholder {
      width: 100% !important;
      max-width: 100% !important;
      display: block !important;
    }
    .hero-split-stack-cell {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .hero-content-banner-image .hero-content-image {
      height: 180px !important;
    }
    .hero-overlay-cell {
      min-height: 280px !important;
      height: 280px !important;
    }
  }
`;
